import {observer} from 'mobx-react';
import FormRow from '../../../../../forms/FormRow';
import FormColumn from '../../../../../forms/FormColumn';
import FormAutocompleteField from '../../../../../components/fields/FormAutocompleteField';
import FormNumberField from '../../../../../components/fields/FormNumberField';

function CreditNoteRefundOnArticleResolutionPanel({allowance, subsectionForm, readOnly = false}) {
    return (
        <FormColumn>
            <FormRow>
                <FormAutocompleteField
                    label="Artículo del reintegro"
                    form={subsectionForm}
                    fieldName="refundArticleId"
                    options={allowance.articleOptions()}
                    readOnly={readOnly}
                />
                <FormNumberField
                    label="Porcentaje (%)"
                    field={subsectionForm.getFieldByName('percentage')}
                    width="100%"
                    disabled={readOnly}
                />
            </FormRow>
        </FormColumn>
    );
}

export default observer(CreditNoteRefundOnArticleResolutionPanel);
